import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id E7A4CEE7-C6E2-4FD6-B0BF-B3DD131100CB
 * name network-strength-off-outline
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/network-strength-off-outline.svg
 * tags
 * - Cellphone / Phone 
 */
export const NetworkStrengthOffOutlineIcon = createSvgIcon(<><path d="M21,1L12.4,9.6L13.85,11.05L19,5.83V16.19L21,18.19M4.77,4.5L3.5,5.77L9.86,12.13L1,21H18.73L20.73,23L22,21.73M11.33,13.6L16.73,19H6" /></>, 'NetworkStrengthOffOutlineIcon');
export default NetworkStrengthOffOutlineIcon